import { ConsentForm, ConsentFormCache, ConsentType } from "intake_shared/src/types";
import { convertToSafeString } from "../utils/utils";
import { Collection } from "intake_shared/src/enum";
import db from "../utils/firestore";

let consentCache: ConsentFormCache = {};

export async function addNewConsentForm(consent_form: ConsentForm) {
    const consentKey = convertToSafeString(consent_form.name, "_").toUpperCase();
    await db
        .collection(Collection.CONSENT_FORM_LINKS)
        .doc(consentKey)
        .set(consent_form);
}

export async function updateConsentCache(): Promise<ConsentFormCache> {
    try {
        const consentDocs = await db.collection(Collection.CONSENT_FORM_LINKS).get();

        if (!consentDocs.empty) {
            consentCache = consentDocs.docs.reduce((cache, doc) => {
                const data = doc.data() as ConsentForm;
                cache[doc.id] = data;
                return cache;
            }, {} as ConsentFormCache);
        }

        return consentCache;
    } catch (error) {
        console.error("Error fetching consent forms data:", error);
        return {};
    }
}

export async function getConsentForms(): Promise<ConsentFormCache> {
    if (Object.keys(consentCache).length > 0) {
        return consentCache;
    }
    let consentForms = await updateConsentCache();
    return consentForms || ({} as ConsentFormCache);
}

export async function addConsentFormType(
    consentFormName: string,
    newType: ConsentType
): Promise<void> {
    try {
        const consentKey = convertToSafeString(consentFormName, "_").toUpperCase();
        const docRef = db.collection(Collection.CONSENT_FORM_LINKS).doc(consentKey);
        const doc = await docRef.get();

        if (!doc.exists) {
            console.error("Consent form does not exist.");
            return;
        }

        const data = doc.data() as ConsentForm;
        const updatedTypes = [...data.types, newType];

        await docRef.update({ types: updatedTypes });
        consentCache[consentKey] = { ...data, types: updatedTypes };
    } catch (error) {
        console.error("Error adding consent form type:", error);
    }
}

export async function updateConsentFormLink(
    consentFormName: string,
    typeId: string,
    newLink: string
): Promise<void> {
    try {
        const consentKey = convertToSafeString(consentFormName, "_").toUpperCase();
        const docRef = db.collection(Collection.CONSENT_FORM_LINKS).doc(consentKey);
        const doc = await docRef.get();

        if (!doc.exists) {
            console.error("Consent form does not exist.");
            return;
        }

        const data = doc.data() as ConsentForm;

        const updatedTypes = data.types.map((type) =>
            type.id === typeId ? { ...type, link: newLink } : type
        );

        await docRef.update({ types: updatedTypes });
        consentCache[consentKey] = { ...data, types: updatedTypes };
    } catch (error) {
        console.error("Error updating consent form link:", error);
    }
}
